import React from 'react';
import { DocumentGroupInfo } from '.';
import { Trans } from '@lingui/react/macro';
import theme from './DocumentTypeGroupingHeader.module.scss';
import { classnames } from '@/utils/html';

interface DocumentTypeGroupingHeaderProps {
    value: DocumentGroupInfo;
    className?: string;
}

const DocumentTypeGroupingHeader: React.FC<DocumentTypeGroupingHeaderProps> = ({ className, value }) => (
    <div className={classnames(theme.container, className)}>
        {value.rootCategory ? value.rootCategory.name : <Trans id="general_heading">General</Trans>}
    </div>
);

export default DocumentTypeGroupingHeader;
